import { Routes, Route } from "react-router-dom"
import { ScreenTemplate } from "../ScreenTemplate"
import { useEffect, useState } from "react"
import { Helpers } from "../../../../biz/data/Helpers"
import { useTranslation } from "react-i18next"

export const Account = () => {
    const { t } = useTranslation();
    return (
        <ScreenTemplate
            header={t("account")}
            text={t("screen_accounts_tagline")}
        //  text="Konto kopplat till företaget"
        >
            <p>
                {t("account")}
            </p>
        </ScreenTemplate>
    )
}

export const Accounts = () => {
    const { t } = useTranslation();

    //const list = Array.from(Array(50).keys());
    const [data, setData] = useState<{ name: string, phone: string, email: string }[]>([])

    useEffect(() => {
        Helpers.delay(500).then(e => {
            setData([])
        })
    }, [])


    return (
        <ScreenTemplate
            header={t("leftmenu_section_account")}
            text={t("screen_accounts_tagline")}
        //text="Konton kopplade till företaget"
        >
            <p>
                {t("accounts")}
            </p>
            <table>
                <thead>
                    <tr>
                        <th>{t("name")}</th>
                        <th>{t("phone")}</th>
                        <th>{t("email")}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(n => (
                        <tr key={n.email}>
                            <td>{n.name}</td>
                            <td>{n.phone}</td>
                            <td>{n.email}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <hr />
        </ScreenTemplate>
    )
}
export const Subscription = () => {
    const { t } = useTranslation();
    return (
        <ScreenTemplate
            header={t("subscription")}
            text={t("screen_subscription_tagline")}
        //text="Din prenumeration"
        >
            <p>
                {t("subscription")}
            </p>
        </ScreenTemplate>
    )
}
